import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbDatepickerModule,
  NbRadioModule,
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbTabsetModule,
  NbUserModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbSpinnerModule,
  NbFormFieldModule,
  NbInputModule,
} from '@nebular/theme';

import { NgxEchartsModule } from 'ngx-echarts';
import { CalendarModule } from 'primeng/calendar';
import {CarouselModule} from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';

import { ThemeModule } from '../@theme/theme.module';
import { DashboardComponent } from './dashboard.component';
import { ContactsComponent } from './widgets/contacts/contacts.component';
import { ElectricityComponent } from './widgets/electricity/electricity.component';
import { ElectricityChartComponent } from './widgets/electricity/electricity-chart/electricity-chart.component';
import { SolarComponent } from './widgets/solar/solar.component';
import { ChartWidgetTinyComponent } from './widgets/charts/chartwidgettiny.component';
import { ChartLineComponent } from './widgets/charts/chartline.component';

// import { StatusCardComponent } from './widgets/status-card/status-card.component';
// import { RoomsComponent } from './widgets/rooms/rooms.component';
// import { RoomSelectorComponent } from './widgets/rooms/room-selector/room-selector.component';
// import { TemperatureComponent } from './widgets/temperature/temperature.component';
// import { TemperatureDraggerComponent } from './widgets/temperature/temperature-dragger/temperature-dragger.component';
// import { TeamComponent } from './widgets/team/team.component';
// import { KittenComponent } from './widgets/kitten/kitten.component';
// import { SecurityCamerasComponent } from './widgets/security-cameras/security-cameras.component';
// import { WeatherComponent } from './widgets/weather/weather.component';
// import { PlayerComponent } from './widgets/rooms/player/player.component';
// import { CalendarComponent } from './widgets/calendar/calendar.component';
// import { ReportKlipComponent } from './widgets/report-klip/report-klip.component';
// import { ReportGridComponent } from './widgets/report-grid/report-grid.component';
// import { CardComponent } from './widgets/card/card.component';
import { WidgetComponent } from './widgets/core/widget.component';
import { WidgetRowComponent } from './widgets/core/widgetrow.component';
import { WidgetsHostDirective } from './widgets/core/widgetshost.component';
import { WidgetHolderComponent } from './widgets/core/widgetholder.component';
import { TableComponent } from './widgets/table/table.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { CustomizedViewService } from '../documents/customizedview.service';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { DashboardDataService } from './dashboard-data.service';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth-guard.service';
import { DownloadReportWidgetComponent } from './widgets/downloadreport/downloadreport.component';
import { MatNativeDateModule } from '@angular/material/core';
import { ImagesCarouselWidgetComponent } from './widgets/images-carousel-widget/images-carousel-widget.component';
import { I18NextModule } from 'angular-i18next';
import { I18N_PROVIDERS } from '../../locale/i18nextConfig';

const NB_MODULES = [
  NbCardModule,
  NbUserModule,
  NbButtonModule,
  MatInputModule,
  NbTabsetModule,
  NbActionsModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbButtonModule,
  NbSpinnerModule,
  NbFormFieldModule,
  NbInputModule,
  NgxEchartsModule,
  NbDatepickerModule,
  MatNativeDateModule,
  MatDatepickerModule
];
const PRIMENG_MODULES = [
  CalendarModule,
  CardModule,
  CarouselModule,
  CascadeSelectModule,
  DropdownModule,
  TableModule,
]

const WIDGETS_COMPONENTS = [
  WidgetHolderComponent,
  WidgetRowComponent,

  TableComponent,
  DownloadReportWidgetComponent,
  ContactsComponent,
  ImagesCarouselWidgetComponent,
  ElectricityComponent,
  ElectricityChartComponent,
  SolarComponent,
  ChartLineComponent,
  ChartWidgetTinyComponent,

  //   StatusCardComponent,
  //   TemperatureDraggerComponent,
  //   RoomSelectorComponent,
  //   TemperatureComponent,
  //   RoomsComponent,
  //   TeamComponent,
  //   KittenComponent,
  //   SecurityCamerasComponent,
  //   WeatherComponent,
  //   PlayerComponent,
  //   CardComponent,
  //   CalendarComponent,
  //   ReportKlipComponent,
  //   ReportGridComponent,
];

const routes: Routes = [{
  canActivate: [AuthGuard],
  path: ':dashboardShortName',
  component: DashboardComponent
}];

@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    NgxEchartsModule,
    FontAwesomeModule,
    RouterModule.forChild(routes),
    I18NextModule,
    ...PRIMENG_MODULES,
    ...NB_MODULES
  ],
  declarations: [
    DashboardComponent,
    WidgetsHostDirective,

    ...WIDGETS_COMPONENTS
  ],
  providers: [
    DashboardDataService,
    I18N_PROVIDERS
  ],
  entryComponents: [...WIDGETS_COMPONENTS],
  exports: [TableComponent]
})
export class DashboardModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
